// VISIT FREQUENCY
export const SET_CARE_PROVIDER_ROLES = 'VFGlobalContext.SET_CARE_PROVIDER_ROLES';
export const SET_ROLE_GROUPS = 'VFGlobalContext.SET_ROLE_GROUPS';
export const SET_PATIENT_TEAM = 'VFGlobalContext.SET_PATIENT_TEAM';
export const SET_PATIENT_ASSIGNMENTS = 'VFGlobalContext.SET_PATIENT_ASSIGNMENTS';
export const SET_ORDERS_MODE = 'VFGlobalContext.SET_ORDERS_MODE';
export const ADD_EDITING_DATA = 'VFGlobalContext.ADD_EDITING_DATA';
export const ADD_ORDER_DATE = 'VFGlobalContext.ADD_ORDER_DATE';
export const CLEAR_EDITING_DATA = 'VFGlobalContext.CLEAR_EDITING_DATA';
export const REMOVE_EDITING_ROLEGROUP = 'VFGlobalContext.REMOVE_EDITING_ROLEGROUP';
export const REMOVE_ORDER_ENTRY = 'VFGlobalContext.REMOVE_ORDER_ENTRY';